<template>
  <a-card :bordered="false">
    <a-spin :spinning="pageLoading">
      <a-form class="m-form" :form="form">
        <a-row type="flex" justify="start" align="top" :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-row type="flex" :gutter="12">
              <a-col :xs="{ span: 24 }" :lg="{ span: 10 }">
                <a-form-item label="Jenis Identitas">
                  <a-select v-decorator="[ 'jenis_identitas', { rules: [{ required: true }], initialValue: profile.jenis_identitas }]">
                    <a-select-option v-for="item in datamaster.jenis_identitas" :key="item.value">{{item.text}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 14 }">
                <a-form-item label="Nomor Identitas">
                  <a-input
                    autocomplete="off"
                    v-decorator="[
                      'no_identitas',
                      { rules: [{ required: true }], initialValue: profile.no_identitas }
                    ]"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-form-item label="Nama Lengkap">
              <a-input
                autocomplete="off"
                v-decorator="[
                  'nama',
                  { rules: [{ required: true }], initialValue: profile.nama }
                ]"
              />
            </a-form-item>
            <a-form-item label="Alamat">
              <a-textarea
                :rows="1"
                v-decorator="[
                  'alamat',
                  { rules: [{ required: true }], initialValue: profile.alamat }
                ]"
              />
            </a-form-item>
            <a-form-item label="No. Telp">
              <a-input
                autocomplete="off"
                v-decorator="[
                  'noTelp',
                  { rules: [{ required: false }], initialValue: profile.no_telp }
                ]"
                @keydown="onlyNumber"
              >
                <a-select
                  slot="addonBefore"
                  v-decorator="['noTelp_code', { initialValue: '62' }]"
                  style="width: 70px"
                >
                  <a-select-option key="62" value="62">+62</a-select-option>
                  <a-select-option key="61" value="61">+61</a-select-option>
                </a-select>
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-row type="flex" :gutter="12">
              <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                <a-form-item label="Tempat Lahir">
                  <a-input
                    autocomplete="off"
                    v-decorator="[
                      'tempat_lahir',
                      {
                        rules: [{ required: true }],
                        initialValue: profile.tempat_lahir
                      }
                    ]"
                  />
                </a-form-item>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                <a-form-item label="Tanggal Lahir">
                  <a-date-picker
                    class="w-full"
                    :format="getDefaultDateFormat"
                    v-decorator="[
                      'tgl_lahir',
                      {
                        rules: [{ required: true }],
                        initialValue: profile.tanggal_lahir
                      }
                    ]"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-form-item label="Jenis Kelamin">
              <a-select
                v-decorator="[
                  'gender',
                  { rules: [{ required: true }], initialValue: profile.gender }
                ]"
              >
              <a-select-option v-for="item in datamaster.jenis_kelamin" :key="item.value">{{item.text}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="email">
              <a-input
                autocomplete="off"
                v-decorator="[
                  'email',
                  {
                    rules: [
                      {
                        type: 'email',
                        message: 'The input is not valid E-mail!'
                      },
                      { required: false }
                    ],
                    initialValue: profile.email
                  }
                ]"
              />
            </a-form-item>
            <a-form-item v-if="mode === 'create'" label="Foto">
              <a-upload
                class="d-block"
                accept="image/*"
                :showUploadList="true"
                :fileList="fotoKaryawan"
                listType="picture"
                :beforeUpload="beforeUpload"
                v-decorator="[
                  'foto',
                  { rules: [{ required: true }] },
                  { valuePropName: 'push' }
                ]"
              >
                <a-button>
                  <a-icon type="upload" />&nbsp; Select Picture
                </a-button>
              </a-upload>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "profile",
  props: ["collectedData", "mode", "datamaster"],
  data() {
    return {
      fotoKaryawan: [],
      profile: {},
      pageLoading: false
    };
  },
  watch: {
    data() {
      this.profile = {
        agama: this.collectedData.profile.agama,
        alamat: this.collectedData.profile.alamat,
        email: this.collectedData.profile.email,
        foto: this.collectedData.profile.foto,
        nama: this.collectedData.profile.nama,
        no_identitas: this.collectedData.profile.no_identitas,
        no_ktp: this.collectedData.profile.no_ktp,
        no_telp: this.collectedData.profile.no_telp,
        status_perkawinan: this.collectedData.profile.status_perkawinan,
        gender: this.collectedData.profile.gender,
        tanggal_lahir: moment(
          this.collectedData.profile.tanggal_lahir,
          this.getDefaultDateFormat
        ),
        tempat_lahir: this.collectedData.profile.tempat_lahir,
        tlc: this.collectedData.profile.tlc,
        tanggungan: this.collectedData.profile.tanggungan,
      };
    }
  },
  computed: {
    ...mapGetters(["getDefaultDateFormat", "getMaster", "getAuth"])
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  methods: {
    moment,
    beforeUpload(file) {
      console.log(file);
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file");
      } else {
        this.fotoKaryawan = [file];
        return false;
      }
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        const telpon = values.noTelp ? (values.noTelp_code + values.noTelp) : '';
        const dataValues = {
          ...values,
          foto: this.fotoKaryawan,
          telpon: telpon
        };

        Event.$emit("createKaryawan", dataValues);
      });
    }
  }
};
</script>

<style></style>
